/*global jwplayer,currentJwplayer,setupVideoPlayer */
function CalculateCarousalOffset(imagePager, currentImage, arrow, $nextImage, imageArrow, offset) {
    if (imagePager.length > 1) {
        currentImage.fadeOut();
    }
    if (arrow.is(".icon-nav-arrow-left") || arrow.is(".icon-nav-arrow-top")) {
        $nextImage = currentImage.prev();
        imageArrow.addClass("active");
        if ($nextImage.length === 0) {
            $nextImage = currentImage.siblings().eq(-1);
        }
        offset = currentImage.width()
        offset = -(offset);
    } else if (arrow.is(".icon-nav-arrow-right") ||
        arrow.is(".icon-nav-arrow-bottom")) {
        $nextImage = currentImage.next();
        imageArrow.addClass("active");
        if ($nextImage.length === 0) {
            $nextImage = currentImage.siblings().eq(0);
        }
        offset = currentImage.width();
    }
    return [offset, $nextImage];
}
var $imageCarouselArrows = $(".image-carousel .icon, .thumbnailContainer .icon"),
    imagePagerLength = $(".ThumbnailSlider ul").children().length,
    arrowBottom = $(".icon.icon-nav-arrow-bottom"),
    arrowTop = $(".icon.icon-nav-arrow-top");
arrowBottom.show();
arrowTop.show();
const imageLengthConst = 4;
if (imagePagerLength > imageLengthConst) {
    arrowTop.show();
    arrowBottom.show();
}
if (imagePagerLength === 5) {
    $(".icon-nav-arrow-top").css('display', 'none');
    $(".icon-nav-arrow-bottom").css('display', 'none');
    $('.disabled').removeClass('disabled');
}
$("ul.image-pager").css({
    height: "451px",
    overflow: "hidden",
    transition: ".9s"
});
$("ul.image-pager li:first-child").addClass("active");
var scrollTopLi = $("ul.image-pager li").outerHeight(true);
var checkImagePager = function () {
    var totalItems = $('ul.image-pager li').length;

    if (totalItems === 5 || totalItems > 5) {
        $(".icon-nav-arrow-top").css('display', 'none');
        $(".icon-nav-arrow-bottom").css('display', 'none');
        $('.disabled').removeClass('disabled');
        $(".fade-top").css('display', 'none');
    }
};
jQuery(function ($) {
    if (window.matchMedia('(max-width: 1118px)').matches) {
        $('.component-product-intro').parents('.section').children('.container').css('padding', '0');
    }
    var totalItems = $('ul.image-pager li').length;
    var currentIndex = $('li.active').index() + 1;
    $('.num').html('' + currentIndex + '/' + totalItems + '');
    if (currentIndex === totalItems && currentIndex > 5 && window.matchMedia('(min-width: 1118px)').matches) {
        $("ul.image-pager").css('margin-top', '-33px');

    } else {
        $("ul.image-pager").css('margin-top', '');
    }


    //onload when first item fade added
    if (currentIndex === 1) {
        $(".fade-bottom").css('display', 'block');
        $(".fade-top").css('display', 'none');
    };
    //onload when less item  
    if (totalItems === 5 || (totalItems < 5)) {
        $(".thumbnailContainer .icon-nav-arrow-bottom, .thumbnailContainer .icon-nav-arrow-top").css('display', 'none');
    }
    //onload disbale added
    setTimeout(() => {
        if ($('ul.image-pager li').first().hasClass('active')) {
            $('.deskCarousel .icon-nav-arrow-right, .deskCarousel .icon-nav-arrow-bottom').removeClass('disabled');
            $('.deskCarousel .icon-nav-arrow-left, .deskCarousel .icon-nav-arrow-top').addClass('disabled');
            /*  checkImagePager();*/
        }

    }, 300)

})
$(document).on('click keypress', '#iconResize', function (event) {
    if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {

        $('.image').each(function (index, value) {
            if ($(this).css('display') === 'block') {
                $(this).find('.lightboxed').click();
            }
        })

    }
})

if (window.matchMedia('(max-width: 576px)').matches) {

    var ThumbLiHeight = $("ul.image-pager li").outerHeight();
    var ThumbLiHeight = ThumbLiHeight + 4;
} else if (window.matchMedia('(max-width: 1118px)').matches) {
    var ThumbLiHeight = $("ul.image-pager li").outerHeight();
    var ThumbLiHeight = ThumbLiHeight + 8;

} else {
    var ThumbLiHeight = $("ul.image-pager li").outerHeight();
    var ThumbLiHeight = ThumbLiHeight + 3;
}
//added margin of the thumbnail li
var thumbLenght = $("ul.image-pager li").length;
var thumbLenght = thumbLenght - 1;

$imageCarouselArrows.on("click keydown", function (event) {
    // Handle click and keyboard "Enter" keypress events
    if (event.type === "click" || (event.type === "keydown" && (event.key === "Enter" || event.key === " "))) {
        // Prevent synthetic click on Enter/Space
        if (event.type === "keydown") {
            event.preventDefault();
        }

        var $arrow = $(this),
            $productContainer = $arrow.closest(".component-product-intro"),
            $carousel = $productContainer.find(".component-image-carousel"),
            $imagePager = $productContainer.find(".image-pager li"),
            //$currentThumnail,
            $currentImage,
            $nextImage,
            offset,
            currentImage;
        currentImage = $carousel.data().currentImage || 0;
        $currentImage = $carousel.find(".image").eq(currentImage);
        if ($imagePager.length > 1) {
            $currentImage.fadeOut();
        }
        if ($arrow.is(".icon-nav-arrow-left") || $arrow.is(".icon-nav-arrow-top")) {
            $nextImage = $currentImage.prev();
            $(this).addClass("active");
            var thumbCurrentIndex = $(".image-pager li.active").index();
            var scrollTopPosition = thumbCurrentIndex * ThumbLiHeight;

            if ($nextImage.length === 0) {
                $nextImage = $currentImage.siblings().eq(-1);
            }
            if ($nextImage.index() === 1) {
                scrollTopPosition = ThumbLiHeight;
            } else if ($nextImage.index() < thumbLenght) {
                scrollTopPosition = scrollTopPosition - ThumbLiHeight;
            } else if ($nextImage.index() === thumbLenght) {
                scrollTopPosition = $nextImage.index() * ThumbLiHeight;
            } else if ($nextImage.index() === thumbLenght) {
                scrollTopPosition = $nextImage.index() * ThumbLiHeight;

            }
        } else if ($arrow.is(".icon-nav-arrow-right") || $arrow.is(".icon-nav-arrow-bottom")) {
            $nextImage = $currentImage.next();
            $(this).addClass("active");

            var thumbCurrentIndex = $("ul.image-pager li.active").index();
            var scrollTopPosition = thumbCurrentIndex * ThumbLiHeight;

            if ($nextImage.length === 0) {
                $nextImage = $currentImage.siblings().eq(0);
            }

            if ($nextImage.index() > 3) {
                scrollTopPosition = scrollTopPosition + ThumbLiHeight;
            } else if ($nextImage.index() === 0) {
                scrollTopPosition = 0;
            }
        }
        if ($nextImage) {
            $carousel.data("current-image", $nextImage.index());
            $nextImage
                .css({
                    left: offset,
                    opacity: 1
                }).show().stop(true, false).animate({
                    left: 0
                }, "slow");
            //  slide pagination count start
            var currentIndexV = $nextImage
                .css({
                    left: offset,
                    opacity: 1
                }).show().stop(true, false).animate({
                    left: 0
                }, "slow").index() + 1;
            var totalItems = $('ul.image-pager li').length;
            $('.num').empty();
            $('.num').html('' + currentIndexV + '/' + totalItems + '');
            if (currentIndexV === totalItems && currentIndexV > 5 && window.matchMedia('(min-width: 1118px)').matches) {
                $("ul.image-pager").css('margin-top', '-33px');
            } else {
                $("ul.image-pager").css('margin-top', '');
            }



            // add diable to btn based on first n last image and fade effect
            function checkActiveClass() {

                //thumbnail going to bottom
                $('.deskCarousel .icon-nav-arrow-left').on('click', function () {
                    $(".fade-bottom").css('display', 'block');
                    $(".fade-top").css('display', 'none');
                    /* checkImagePager();*/
                })
                //thumbnail going to up
                $('.deskCarousel .icon-nav-arrow-right').on('click', function () {
                    /* checkImagePager();*/
                    $(".fade-bottom").css('display', 'none');
                    $(".fade-top").css('display', 'block');
                })
                setTimeout(() => {

                    if ($('ul.image-pager li').first().hasClass('active')) {
                        /* checkImagePager();*/
                        $('.deskCarousel .icon-nav-arrow-right, .deskCarousel .icon-nav-arrow-bottom').removeClass('disabled');
                        $('.deskCarousel .icon-nav-arrow-left, .deskCarousel .icon-nav-arrow-top').addClass('disabled');
                        $(".fade-bottom").css('display', 'block');
                        $(".fade-top").css('display', 'none');
                    }
                }, 300)
                setTimeout(() => {

                    if ($('ul.image-pager li').last().hasClass('active')) {
                        /* checkImagePager();*/
                        $('.deskCarousel .icon-nav-arrow-right, .deskCarousel .icon-nav-arrow-bottom').addClass('disabled');
                        $('.deskCarousel .icon-nav-arrow-left, .deskCarousel .icon-nav-arrow-top').removeClass('disabled');
                        $(".fade-bottom").css('display', 'none');
                        $(".fade-top").css('display', 'block');
                    }
                }, 300)
            }

            // Call checkActiveClass on page load and after updates
            checkActiveClass();
            $imagePager
                .removeClass("active")
                .eq($nextImage.index())
                .addClass("active");
            const nextImageConst = 3;
            //for tab and mob
            if (window.matchMedia('(max-width: 1118px)').matches) {
                if ($nextImage.length === 0) {
                    $("ul.image-pager").animate({
                        scrollLeft: 0
                    },
                        "slow"
                    );
                }
                if ($nextImage.index() > nextImageConst) {

                    $("ul.image-pager").animate({
                        scrollLeft: scrollTopPosition
                    },
                        "slow"
                    );
                } else {
                    $("ul.image-pager").animate({
                        scrollLeft: 0
                    }, "slow");
                }
            }
            //for desk
            else {
                if ($nextImage.length === 0) {

                    $("ul.image-pager").animate({
                        scrollTop: 0
                    },
                        "slow"
                    );
                }
                if ($nextImage.index() > nextImageConst) {
                    $("ul.image-pager").animate({
                        scrollTop: scrollTopPosition
                    },
                        "slow"
                    );
                } else {
                    $("ul.image-pager").animate({
                        scrollTop: 0
                    }, "slow");
                }
            }

        }
    }
});
if ($(".image-carousel").length > 0 && typeof Hammer != "undefined") {
    var imageCarouselSwipe = new Hammer($(".image-carousel").get(0));
    imageCarouselSwipe.on("swipeleft", function () {
        $imageCarouselArrows.filter(".icon-nav-arrow-right").trigger("click");
    });
    imageCarouselSwipe.on("swiperight", function () {
        $imageCarouselArrows.filter(".icon-nav-arrow-left").trigger("click");
    });
}

$(".image-pager li").on('click keydown', function (event) {
    if (event.type === "click" || (event.type === "keydown" && (event.key === "Enter" || event.key === " "))) {
        // Prevent synthetic click on Enter/Space
        if (event.type === "keydown") {
            event.preventDefault();
        }
        $('.image-pager li').removeClass('active');
        var $imagePagerItem = $(this),
            $productContainer = $imagePagerItem.closest(".component-product-intro"),
            $carousel = $productContainer.find(".component-image-carousel"),
            $imagePagers = $(this),
            $currentImage,
            currentImage;
        const fadeOutInterval = 400;
        const fadeInInterval = 400;


        currentImage = $carousel.data().currentImage || 0;
        $currentImage = $carousel.find(".image").eq(currentImage);
        $carousel.find(".image").fadeOut(fadeOutInterval);
        //Show right image
        $currentImage = $carousel.find(".image").eq($imagePagerItem.index());
        $carousel.data().currentImage = $imagePagerItem.index();
        $currentImage.fadeIn(fadeInInterval);
        $imagePagers.removeClass("active");
        $imagePagerItem.addClass("active");
        if ($imagePagerItem.hasClass('active')) {
            var totalItems = $('ul.image-pager li').length;
            var currentIndex = $imagePagerItem.index() + 1;
            $('.num').html('' + currentIndex + '/' + totalItems + '');
        }
    }
});
let lastNavButtonType = "lightboxed--bttn_close";
function focusLastNavButton() {
    // Guard: only if we have a trigger
    if (!lastNavButtonType) return;
    var $activeFrame = $(".lightboxed--frame.lightboxed--active");
    if (!$activeFrame.length) return;
    // Try to find a button/div with same id inside the active frame
    var $focusTarget = $activeFrame.find("#" + lastNavButtonType);
    if ($focusTarget.length && $focusTarget.is(":visible")) {
        $focusTarget.focus();
    }
}
(function ($, window, document, undefined) {
    var LightboxFunc = 'Lightboxed';
    var namespace = 'lightboxed--';

    function Lightboxed(element, options) {
        jQuery.extend(
            this, {
            Obj: element,
            _name: LightboxFunc,
            _defaults: $.fn.lightboxed.defaults,
            options: jQuery.extend({}, $.fn.lightboxed.defaults, options),
            lightbox: {},
            cache: {},
            index: false,
            touch: {},
        }
        );
        this.init();
    }
    $.extend(Lightboxed.prototype, {
        init: function () {
            var that = this;
            this.CacheObj = (jQuery(document).find('#' + namespace + 'cache').length > 0) ? jQuery(document).find('#' + namespace + 'cache') : jQuery('<div id="' + namespace + 'cache" />').appendTo('body');
            this.cache.container = jQuery('<div id="' + this.uniq + '" />').appendTo(this.CacheObj);
            this.cache.content = jQuery('<div class="' + namespace + 'cached_content" />').appendTo(this.cache.container);
            if (this.Obj.length > 1) {
                this.cache.thumbs = jQuery('<div class="' + namespace + 'cached_thumbs" />').appendTo(this.cache.container);
            }
            this.Obj.each(function () {
                that.addToCache(this);
            });
            this.lightbox.container = (jQuery(document).find('#' + namespace + 'container').length > 0) ? jQuery(document).find('#' + namespace + 'container') : jQuery('<div id="' + namespace + 'container" />').addClass(this.options.lightboxCloseClass).appendTo('body');
            this.lightbox.stage = (this.lightbox.container.find('#' + namespace + 'stage').length > 0) ? this.lightbox.container.find('#' + namespace + 'stage') : jQuery('<div id="' + namespace + 'stage" />').appendTo(this.lightbox.container);
            this.lightbox.content = (this.lightbox.stage.find('#' + namespace + 'content').length > 0) ? this.lightbox.stage.find('#' + namespace + 'content') : jQuery('<div id="' + namespace + 'content" />').appendTo(this.lightbox.stage);
            this.lightbox.thumbs = (this.lightbox.container.find('#' + namespace + 'thumbs').length > 0) ? this.lightbox.container.find('#' + namespace + 'thumbs') : jQuery('<div id="' + namespace + 'thumbs" />').appendTo(this.lightbox.stage);
            this.lightbox.close = (this.lightbox.container.find('#' + namespace + 'bttn_close').length > 0) ? this.lightbox.container.find('#' + namespace + 'bttn_close') : jQuery('<div role="button" tabindex="0" id="' + namespace + 'bttn_close" class="icon-validation" />');
            this.lightbox.prev = (this.lightbox.container.find('#' + namespace + 'bttn_prev').length > 0) ? this.lightbox.container.find('#' + namespace + 'bttn_prev') : jQuery('<div role="button" tabindex="0" id="' + namespace + 'bttn_prev" class="icon icon-nav-arrow-left"/>');
            this.lightbox.next = (this.lightbox.container.find('#' + namespace + 'bttn_next').length > 0) ? this.lightbox.container.find('#' + namespace + 'bttn_next') : jQuery('<div role="button" tabindex="0" id="' + namespace + 'bttn_next" class="icon icon-nav-arrow-right"/>');
            // Add counter display element
            this.lightbox.counter = (this.lightbox.container.find('#' + namespace + 'counter').length > 0) ? this.lightbox.container.find('#' + namespace + 'counter') : jQuery('<div id="' + namespace + 'counter" class="lightbox-counter" />').appendTo(this.lightbox.container);
            this.registerEvents('init');
        },
        addToCache: function (element) {
            if ((jQuery(element).attr('data-link') || jQuery(element).attr('href') || jQuery(element).attr('data-src') || jQuery(element).attr('src')).match('jpg|gif|png|JPG|GIF|PNG|JPEG|jpeg|svg|SVG|tif|TIF|bmp|BMP')) {
                var $element = jQuery(element);
                var altText = $element.attr("alt");
                if (!altText) {
                    var $nestedImg = $element.find("img").first();
                    if ($nestedImg.length) {
                        altText = $nestedImg.attr("alt") || "";
                    }
                }
                var content = jQuery('<img />')
                    .attr('src', (jQuery(element).attr('data-link') || jQuery(element).attr('href') || jQuery(element).attr('src')))
                    .attr('alt', altText)
                    .attr('data-caption', jQuery(element).attr('data-caption'));
            } else if ((jQuery(element).attr('data-link') || jQuery(element).attr('href')).match('^#') && jQuery((jQuery(element).attr('data-link') || jQuery(element).attr('href'))).length > 0) {
                var content = jQuery(jQuery(element).attr('data-link') || jQuery(element).attr('href')).html();
            } else if (jQuery(element).hasClass("jw-video-slide")) {
                // JW Player slide - create container instead of <video>
                var content = jQuery('<div id="jw-video-placeholder"></div>');
            } else {
                var content = jQuery('<video class="vdo" controls muted />')
                    //.attr('src', (jQuery(element).attr('data-link') || jQuery(element).attr('href')) + "?autoplay=1")
                    .attr('src', (jQuery(element).attr('data-link') || jQuery(element).attr('href')))
                    .attr('width', jQuery(element).attr('data-width'))
                    .attr('height', jQuery(element).attr('data-height'))
                    .attr('allowfullscreen', 'true');
            }
            jQuery('<div class="' + namespace + 'frame" />').append(
                jQuery('<div class="' + namespace + 'innerFrame" />')
                    .append(jQuery('<div role="button" tabindex="0" id="' + namespace + 'bttn_close" class="icon-validation"  aria-label="Close button"/>').append(jQuery('<svg data-v-6a943414="" width="24" height="24" style="fill: white;" xmlns="http://www.w3.org/2000/svg" class="close-icon"><path d="M6.414 5A1 1 0 1 0 5 6.414L10.586 12 5 17.586A1 1 0 1 0 6.414 19L12 13.414 17.586 19A1 1 0 1 0 19 17.586L13.414 12 19 6.414A1 1 0 1 0 17.586 5L12 10.586 6.414 5Z"></path></svg>')))
                    .append(content)
                    .append((jQuery(element).attr('data-caption') !== undefined) ? jQuery('<div class="' + namespace + 'caption" />').html(jQuery(element).attr('data-caption')) : '')
                    .append(jQuery('<div role="button" tabindex="0" id="lightboxed--bttn_prev" class="icon icon-nav-arrow-left bttn_prev" aria-label="Previous slide"/> '))
                    .append(jQuery('<div role="button" tabindex="0" id="lightboxed--bttn_next" class="icon icon-nav-arrow-right bttn_next" aria-label="Next slide"/> '))
            )
                .appendTo(this.cache.content);
            if (this.Obj.length > 1) {
                jQuery('<div class="' + namespace + 'thumb" role="button" tabindex="0"/>')
                    .append(
                        jQuery('<div class="' + namespace + 'thumb_border" />')
                            .append(jQuery('<img />').attr('src', (jQuery(element).attr('data-src') || jQuery(element).attr('src') || jQuery(element).attr('data-link') || jQuery(element).attr('href')))
                                .attr("alt", altText))
                    )
                    .appendTo(this.cache.thumbs);
            }
        },
        resizeContent: function () {
            var that = this;
            this.lightbox.content
                .width(jQuery(window).width() * this.lightbox.content.children().length)
                .height(this.cache.thumbs ? jQuery(window).height() - this.lightbox.thumbs.height() : jQuery(window).height())
                .children()
                .width(jQuery(window).width() - 2 * this.options.content.spacing)
                .height(this.lightbox.content.height());
            this.lightbox.content.children().each(function (index) {
                jQuery(this).css('left', jQuery(window).width() * index + that.options.content.spacing)
            });
        },
        open: function (event, element) {
            var that = this;
            this.triggerElement = element;
            if (this.cache.thumbs && this.options.thumbs !== false) {
                this.lightbox.thumbs
                    .width((this.options.thumbs.size + this.options.thumbs.spacing) * (this.cache.thumbs.children().length))
                    .height(this.options.thumbs.size + 2 * this.options.thumbs.spacing)
                    .html(this.cache.thumbs.clone(true).html())
                    .show()
                    .children()
                    .width(this.options.thumbs.size)
                    .height(this.options.thumbs.size)
                    .css('margin', this.options.thumbs.spacing + 'px ' + this.options.thumbs.spacing / 2 + 'px');
                this.registerEvents('thumbs');
                jQuery('.bttn_next').show();
                jQuery('.bttn_prev').show();
            }
            this.lightbox.content.html(this.cache.content.clone(true).html());
            if (this.lightbox.content.children().length > 1 && this.options.loop === true) {
                this.phantoms = {
                    left: jQuery(this.lightbox.content.children().get(this.lightbox.content.children().length - 1)).clone().addClass(namespace + 'phantom-left').prependTo(this.lightbox.content),
                    right: jQuery(this.lightbox.content.children().get(1)).clone().addClass(namespace + 'phantom-right').appendTo(this.lightbox.content)
                };
            }
            this.resizeContent();
            this.change(event, this.Obj.index(element));
            this.registerEvents('lightbox');
            this.lightbox.container.toggleClass(this.options.lightboxCloseClass + ' ' + this.options.lightboxOpenClass).fadeIn(this.options.delay, function () {
                that.lightbox.container.attr("tabindex", "-1").focus();
            });
            jQuery('html').css('overflow', 'hidden');
        },
        updateCounter: function (index) {
            var totalSlides = this.cache.content.children().length;
            this.lightbox.counter.text(' ' + (index + 1) + ' / ' + totalSlides);
        },
        close: function (event) {
            var that = this;
            this.deregisterEvents();
            //for JW Player
            var currentPlayer = currentJwplayer.getCurrentPlayer();
            if (currentPlayer) {
                try {
                    currentPlayer.remove();
                    currentJwplayer.setCurrentPlayer(null);
                } catch (e) { }
            }
            //
            jQuery("#jw-video-container-*").remove();
            this.lightbox.container.toggleClass(this.options.lightboxCloseClass + ' ' + this.options.lightboxOpenClass).fadeOut(this.options.delay, function () {
                that.lightbox.container.attr('style', '');
                that.lightbox.content.html('').attr('style', '');
                that.lightbox.thumbs.html('').attr('style', '').hide();
                jQuery('.bttn_next').hide();
                jQuery('.bttn_prev').hide();
                that.index = false;
                jQuery('html').css('overflow', 'auto');
            });
            if (this.triggerElement) {
                jQuery(this.triggerElement).focus();
                this.triggerElement = null;
            }
        },
        change: function (event, element) {
            var that = this;
            var index = (typeof (element) == 'number') ? element : jQuery(element).index();
            if (this.lightbox.content.children().length === 1) {
                this.lightbox.content.children().addClass(namespace + 'active');
            }
            if (this.lightbox.content.children().length > 1) {
                var offset = (this.options.loop === true) ? jQuery(window).width() * -(index + 1) : jQuery(window).width() * -index;
                if (index === -1) {
                    index = this.lightbox.content.children().length - 3;
                    setTimeout(function () {
                        var offset = jQuery(window).width() * -(index + 1);
                    }, this.options.delay);
                } else if (index === this.lightbox.content.children().length - 2) {
                    index = 0;
                    setTimeout(function () {
                        var offset = jQuery(window).width() * -(index + 1);
                    }, this.options.delay);
                } else {
                    setTimeout(function () {
                        that.lightbox.content.css('transition', 'none');
                    }, this.options.delay);
                }
                this.lightbox.content.children().removeClass(namespace + 'active');
                jQuery(this.lightbox.content.children().get(index + 1)).addClass(namespace + 'active');
                this.lightbox.thumbs.children().removeClass(namespace + 'active');
                jQuery(this.lightbox.thumbs.children().get(index)).addClass(namespace + 'active');
                if (this.lightbox.thumbs.width() > jQuery(window).width()) {
                    var offset = -(index * (this.options.thumbs.size + this.options.thumbs.spacing)) - ((this.options.thumbs.size + this.options.thumbs.spacing) / 2);
                }
                // Handle JW Player for video slide
                // JW Player for video slide
                // JW Player activation - ONLY active frame, skip phantoms
                var $activeFrame = jQuery(
                    ".lightboxed--frame.lightboxed--active:not(.lightboxed--phantom-left):not(.lightboxed--phantom-right)",
                );
                if ($activeFrame.length && $activeFrame.find("#jw-video-placeholder").length) {
                    var $placeholder = $activeFrame.find("#jw-video-placeholder");

                    // Cleanup any previous JW
                    var oldId = $placeholder
                        .attr("id")
                        .replace("jw-video-placeholder", "jw-video-container-");
                    if (jwplayer && jwplayer(oldId)) {
                        try {
                            jwplayer(oldId).remove();
                        } catch (e) { }
                    }

                    // Create unique real container
                    var containerId = "jw-video-container-" + Date.now();
                    $placeholder.attr("id", containerId);

                    // Video data from original anchor
                    var $videoLink = jQuery(".jw-video-slide");
                    var urlHref = $videoLink.attr("href");
                    var urlHls = $videoLink.attr("data-video-url-hls");
                    var videoName = $videoLink.attr("data-video-name") || "Product Video";

                    // Use YOUR setupVideoPlayer
                    var player = setupVideoPlayer(containerId, {
                        playlist: [
                            {
                                file: urlHls || urlHref,
                                title: videoName,
                                description: "Video in lightboxed gallery",
                            },
                        ],
                        width: "100%",
                        aspectratio: "16:9",
                        autostart: true,
                        mute: true,
                    });
                    currentJwplayer.setCurrentPlayer(player);
                    currentJwplayer.setCurrentPlayerElement($placeholder[0]);
                }
                this.index = index;
                jQuery('html').css('overflow', 'hidden');
                this.updateCounter(index);
                // After updates and (if needed) after timeout
                if (!this.lastEventFromThumb) {
                    setTimeout(focusLastNavButton, this.options.delay + 5);
                }
                this.lastEventFromThumb = false; // reset
            }
        },
        next: function (event) {
            var that = this;
            this.change(event, this.index + 1);
        },
        prev: function (event) {
            var that = this;
            this.change(event, that.index - 1);
        },
        registerEvents: function (scope) {
            var that = this;
            if (scope === 'init') {
                this.Obj.each(function () {
                    jQuery(this).on('click', function (event) {
                        event.preventDefault();
                        that.open.call(that, event, this);
                    });
                });
            }
            if (scope === 'lightbox') {
                this.lightbox.close.on('click', function (event) {
                    that.close.call(that, event);
                });
                jQuery('#lightboxed--container').on('click', function (event) {
                    that.close.call(that, event);
                });
                jQuery(".icon-validation").on("click keydown", function (event) {
                    if (event.type === "click" || event.key === "Enter") {
                        lastNavButtonType = "lightboxed--bttn_close";
                        that.close.call(that, event);
                    }
                });
                jQuery(".lightboxed--frame").click(function (e) {
                    e.stopPropagation();
                });
                jQuery(".lightboxed--frame, #lightboxed--bttn_next, #lightboxed--bttn_prev, #lightboxed--thumbs").click(function (e) {
                    e.stopPropagation();
                });
                jQuery(".lightboxed--innerFrame").click(function (e) {
                    if (jQuery('html').css('overflow', 'hidden')) {
                        jQuery('html').css('overflow', 'hidden');
                    };
                })
                jQuery(".bttn_next").on("click keydown", function (event) {
                    if (event.type === "click" || event.key === "Enter") {
                        lastNavButtonType = "lightboxed--bttn_next";
                        that.next.call(that, event);
                    }
                });
                jQuery(".bttn_prev").on("click keydown", function (event) {
                    if (event.type === "click" || event.key === "Enter") {
                        lastNavButtonType = "lightboxed--bttn_prev";
                        that.prev.call(that, event);
                    }
                });
                jQuery(window).on('resize', function (event) {
                    that.resizeContent.call(that, event);
                });
            }
            if (scope === 'thumbs') {
                this.lightbox.thumbs.children().on('click keydown', function (event) {
                    if (event.type === "click" || event.key === "Enter") {
                        // mark that this came from a thumbnail
                        that.lastEventFromThumb = true;
                        that.change.call(that, event, this);

                        // return focus to the same thumb
                        $(this).focus();
                    }
                });
                jQuery('html').css('overflow', 'hidden');
            }
        },
        deregisterEvents: function () {
            var that = this;
            this.lightbox.close.off();
            jQuery('.bttn_next').off();
            jQuery('.bttn_prev').off();
            jQuery(window).off('resize');
            this.lightbox.content.off();
            this.lightbox.thumbs.children().off();
            this.lightbox.thumbs.off();
        }
    });
    $.fn.indexof = function (a) {
        var f;
        for (var i = 0; i < jQuery(this).length; i++) {
            if (jQuery(this).get(i) === a) {
                f = i;
            }
        }
        return f;
    };
    $.fn.lightboxed = function (options) {
        var createInstance = function () {
            if (!$.data(this, "Lightbox_" + LightboxFunc)) {
                $.data(this, "Lightbox_" + LightboxFunc, new Lightboxed(jQuery(this), options));
            }
        };
        var grouped = {};
        jQuery(this).filter('[rel]').each(function () {
            var group = jQuery(this).attr('rel');
            if (grouped.hasOwnProperty(group)) {
                grouped[group].push(this);
            } else {
                grouped[group] = [this];
            }
        });
        jQuery.each(grouped, createInstance);
        jQuery.each(jQuery(this).filter(':not([rel])'), createInstance);
        return this;
    };
    $.fn.indexOf = function (e) {
        var ret = false;
        var string = jQuery(e)[0].outerHTML;
        jQuery(this).each(function (i, e) {
            if (jQuery(this)[0].outerHTML === string) {
                ret = i;
                return false;
            }
        });
        return ret;
    };
    $.fn.lightboxed.defaults = {
        lightboxOpenClass: namespace + 'lightbox_open',
        lightboxCloseClass: namespace + 'lightbox_close',
        delay: 500,
        loop: true,
        thumbs: {
            size: 60,
            spacing: 10
        },
        content: {
            spacing: 10
        },
        swipe: {
            horizontalOffset: 0.2,
            verticalOffset: 0.33,
        }
    };
})(jQuery, window, document);
jQuery('.lightboxed').lightboxed();
jQuery("#lightboxed--container").on("keydown", function (e) {
    if (e.key === "Tab") {
        var focusableElements = jQuery(this)
            .find('[role="button"], a, button, input, select, textarea')
            .not(".lightboxed--phantom-left, .lightboxed--phantom-right")
            .filter(":visible");
        var firstElement = focusableElements.first()[0];
        var lastElement = focusableElements.last()[0];
        // If focus left container, reset to first focusable
        if (!jQuery("#lightboxed--container").has(document.activeElement).length) {
            e.preventDefault();
            firstElement.focus();
            return;
        }
        if (e.shiftKey) {
            // Shift + Tab
            if (document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            }
        } else {
            // Tab
            if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    }
});